import { render, staticRenderFns } from "./Editor-Image.vue?vue&type=template&id=b16a7f6c"
import script from "./Editor-Image.vue?vue&type=script&lang=js"
export * from "./Editor-Image.vue?vue&type=script&lang=js"
import style0 from "./Editor-Image.vue?vue&type=style&index=0&id=b16a7f6c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports